export default __webpack_public_path__ + "static/media/carou3.d1717019.jpg";